import styles from './requestMobile.module.css';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, Select, TextField, MenuItem, FormControlLabel, Checkbox } from "@mui/material";
import { Plus, UploadCloud, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { useEffect } from "react";
import axios from 'axios';
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { toast } from 'react-smart-toaster';

const RequestMobile = ({ isPanelOpen, onToggle, requestData, setRequestData, setLoading }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { user, isAuthenticated } = useAuth0();
  const [descVal, setDescVal] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [deleteType, setDeleteType] = useState(0);

  useEffect(() => {
    if (requestData) {
      setDescVal(requestData?.description);
    }
  }, [requestData]);

  useEffect(() => {
    const handler = setTimeout(async () => {

      if (descVal !== '' && requestData?.id) {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id, { description: descVal }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((response) => {

          setRequestData(prev => {
            return { ...prev, description: response.data.data?.description };
          });


        }).catch(() => { });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [descVal, getAccessTokenSilently]);

  const deleteConfirm = async () => {
    setOpenDeleteModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setRequestData(prev => {
        if (deleteType === 1) {
          let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
          return { ...prev, resolve_images: images };
        } else {
          let images = prev?.images?.filter(i => i?.id !== deleteId);
          return { ...prev, images: images };
        }
      });

      let logData = {
        'title': 'Maintenance request image deleted',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => { });
  }

  const fileHandler = async (e) => {
    let extErr = false;
    let sizeErr = false;
    let files = e.target.files;
    let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

    if (files.length > 0) {
      if (allowedExtensionArr.length > 0) {
        let fileName = files[0].name;
        let fileSize = files[0].size;
        let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        fileNameExt = '.' + fileNameExt;

        if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
          extErr = true;
        }

        if (fileSize >= 5242880) {
          sizeErr = true;
        }
      }
    }

    if (extErr) {
      toast.error("File type is not allowed.");
      return false;
    }

    if (sizeErr) {
      toast.error("File size should not be greater than 5 MB.");
      return false;
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setLoading(true);

    let formData = new FormData();
    formData.append("image", files[0]);

    axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/upload', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(response => {
      setLoading(false);

      setRequestData(prev => {
        let images = response.data.data.concat(prev?.images);
        return { ...prev, images: images };
      });

      let logData = {
        'title': 'Maintenance request image uploaded',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);

    }).catch(error => {
      setLoading(false);
    });
  }


  return (<>
    <div className={`${styles.AccordionList}`}>
      <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("two")}>
        <p className={`${styles.Title}`}>Request</p>
        <img src="/static/img/downTriangle.svg" alt="" />
      </div>
      <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
        <div className={`${styles.AccouFormGroup}`}>
          <form>
            <div className={`${styles.ReqAddRow}`}>
              <div className={`${styles.ReqAddFormSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <label className={`${styles.FilterLabel}`}>Describe the Maintenance Issue</label>
                    <TextField id="outlined-multiline-static" label="Add Description*" multiline rows={6} value={descVal} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1)} onChange={(e) => { setDescVal(e.target.value); }} />
                  </div>
                </div>
                <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                  <label className={`${styles.FilterLabel}`}>Share a Documents/Photos</label>
                  <div className={`${styles.FileIMGDiv}`}>
                    {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <div className={`${styles.FileUpDuBUDiv}`}>
                      {requestData?.images?.length === 0 && (<label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Documents/Photos</label>)}
                      <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                      {requestData?.images?.length === 0 && (<p className={`${styles.UploadText}`}>File size upto 10 MB. JPG, PNG, PDF, DOC, XLX file only</p>)}
                    </div>}

                    <div className={`${styles.UpIMGSec}`}>
                      {requestData?.images?.map((item, index) => {
                        return (<div className={`${styles.ImgFile}`}>
                          {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                            <img src="/static/img/docIcon.png" alt="" />
                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                          </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                            <img src="/static/img/excelIcon.png" alt="" />
                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                          </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                            <img src="/static/img/pdfIcon.png" alt="" />
                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                          </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" />)))}
                          {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <Button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(0); }}> <X /> </Button>}
                        </div>)
                      })}
                      {requestData?.images?.length > 0 && (<label className={`${styles.TakePhoteSQRBU}`} for="file-upload"><Plus /></label>)}
                      {requestData?.images?.length === 0 && (<div className={`${styles.NoImgDiv}`}>
                        <img src="/static/img/no-photo.png" alt="" />
                      </div>)}
                    </div>
                  </div>
                </div>

                {requestData?.title === "Electrical/Mount Television" && <div className={`${styles.DisclaimerText}`}>
                  <p><span>TV Mount Waiver Agreement</span><br />We recommend that the tenant be present in their unit during the TV mounting appointment to ensure the installation proceeds smoothly. Please be advised that the property management team and its contractors are <span>not liable for any damage to the TV or related equipment during or after installation.</span></p>
                  <p>If adjustments or re-mounting are requested after the initial installation, a <span>$100 service fee</span> will apply. <br />By submitting this maintenance request, you acknowledge and agree to the terms of this waiver.</p>
                  <p>Additionally, if the appointment cannot be completed for any reason such as missing parts, incorrect mounting instructions, or other issues that prevent installation, a <span>$100 service fee</span> will be required to reschedule the appointment.</p>
                  <p>By submitting this maintenance request, you acknowledge that you have read and agree to these terms.</p>
                  <FormControlLabel className={`${styles.FormCheckbox} FormCheckbox`}
                    control={<Checkbox
                      checked
                      disabled
                    />}
                    label="I have read and agree to the terms of the TV Mount Waiver Agreement."
                  />
                </div>}

                <div className={`${styles.DisclaimerText} ${styles.Blue}`}>
                  <p>By submitting this request, you confirm that the information provided is accurate to the best of your knowledge. </p>
                  <p><span>Service availability, estimated time, and charges may vary based on the issue</span>. Any additional work or cost will be communicated before proceeding.</p>
                  <FormControlLabel className={`${styles.FormCheckbox} FormCheckbox`}
                    control={<Checkbox
                      checked={parseInt(requestData?.is_tenant_timeslot) === 0}
                      disabled
                    />}
                    label="You authorize our service team to enter your apartment and carry out the request repair"
                  />
                  <FormControlLabel className={`${styles.FormCheckbox} FormCheckbox`}
                    control={<Checkbox
                      checked={parseInt(requestData?.is_tenant_timeslot) === 1}
                      disable
                    />}
                    label="I would like to be present at home during the maintenance call. I will available during the following  time slot."
                  />
                  {parseInt(requestData?.is_tenant_timeslot) === 1 && <>
                    <div className={`${styles.FormContentSelect} FormGroup`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Select Time*</InputLabel>
                        <Select
                          label="Select Time*"
                          value={requestData?.schedule_time}
                          disabled
                        >
                          <MenuItem value={requestData?.schedule_time}>{requestData?.schedule_time}</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </>}
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Dialog
      open={openDeleteModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setOpenDeleteModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to delete the image?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The image will be removed immediately.You can't undo this action.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
        <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
      </DialogActions>
    </Dialog>
  </>)
}

export default RequestMobile;